<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :search-input.sync="search"
    :label="label"
    :rules="[v => !!v || '']"
    height="44"
    return-object
    hide-details
    browser-autocomplete="nope"
    no-filter
    no-data-text="Нет данных"
    outline
    :disabled="disabled"
    :menu-props="menuPropsClose"
    @change="handleItemChange"
    @click="closeMenuPropsOnClick(false)"
  >
    <template v-slot:append>
      <AddReferenceBtn @click="createNew" />
    </template>
  </v-autocomplete>
</template>

<script>
import AddReferenceBtn from "../../../../components/AddReferenceBtn.vue";
import CloseDropdownList from "../../../../mixins/close-dropdown-list.js";
import { NestedEditorsEventBus } from "../../../../components/nested-editors/nested-editors-event-bus.js";
import {
  getFactoryLoadingPlaceReference,
  searchFactoryLoadingPlace,
  getFactoryLoadingPlaceAddress,
} from "../../../../backend/newShippingApi.js";

export default {
  components: { AddReferenceBtn },
  mixins: [CloseDropdownList],
  props: ["value", "factoryId", "label", "disabled"],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      resource: "loading-places",
      componentName: "LoadingPlaceModal",
    };
  },
  computed: {
    readonly() {
      return this.factoryId ? false : true;
    },
  },
  watch: {
    factoryId() {
      this.getData();
    },
    value: {
      handler() {
        if (!this.value) {
          this.selected = null;
          this.search = null;
          this.items = [];
          return;
        }
        if (
          this.selected &&
          this.value.id === this.selected.value &&
          this.value.title === this.search
        ) {
          return;
        }
        const selectedItem = this.items.find((i) => i.value === this.value.id);
        if (selectedItem) {
          this.selected = selectedItem;
          this.search = selectedItem.text;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.getData();
        return;
      } else {
        if (this.selected && this.selected.text === this.search) {
          return;
        }

        setTimeout(() => {
          if (!this.search) {
            this.selected = null;
            this.items = [];
            return;
          }
          this.findFactoryLoadingPlace();
        }, 500);
      }
    },
  },
  created() {
    NestedEditorsEventBus.$on("create-" + this._uid, (createdId) => {
      this.getFactoryLoadingPlaceReference(createdId);
      this.$emit("input");
    });
    if (this.value) {
      this.setSelectedElement(this.value);
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      (newVal) => {
        if (newVal) {
          this.getData();
        }
      },
    );
  },
  methods: {
    handleItemChange() {
      this.$emit(
        "input",
        this.selected
          ? { id: this.selected.value, title: this.selected.text }
          : null,
      );
    },
    async getData() {
      if (!this.factoryId) {
        this.selected = null;
        this.search = null;
        this.items = [];
        return;
      }

      this.items = await getFactoryLoadingPlaceAddress(this.factoryId);
      if (this.items.length > 0 && !this.selected) {
        this.selected = this.items[0];
        this.handleItemChange();
      }
    },
    createNew() {
      this.closeMenuPropsOnClick(true);
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: "Адрес места погрузки",
        uid: this._uid,
        component: this.componentName,
        params: { factoryId: this.factoryId },
      });
    },
    setSelectedElement(value) {
      const newItem = {
        value: value.id,
        text: value.title,
      };
      this.items.push(newItem);
      this.selected = newItem;
    },
    async getFactoryLoadingPlaceReference(id) {
      const res = await getFactoryLoadingPlaceReference(this.factoryId, id);
      this.setSelectedElement({ id: res.Id, title: res.Title });
    },
    async findFactoryLoadingPlace() {
      this.items = await searchFactoryLoadingPlace(this.factoryId, this.search);
    },
  },
};
</script>
